import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { salonInfo } from '../data/mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Inicio', href: '#hero' },
    { label: 'Nosotros', href: '#about' },
    { label: 'Servicios', href: '#services' },
    { label: 'Sucursales', href: '#locations' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const openWhatsApp = () => {
    const message = `¡Hola! Me gustaría agendar una cita en ${salonInfo.name}.`;
    const whatsappUrl = `https://wa.me/${salonInfo.whatsapp.replace(/\+/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-40 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 shadow-lg backdrop-blur-md border-b border-neutral-200'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('#hero');
            }}
            className="flex items-center gap-3"
          >
            <img 
              src={salonInfo.logo} 
              alt="Saldívar Villar Logo" 
              className="h-14 w-14 rounded-full object-cover shadow-md border-2 border-[#d4af37]/30"
            />
            <div className="hidden sm:block">
              <span className={`font-serif text-lg font-semibold transition-colors ${
                isScrolled ? 'text-neutral-800' : 'text-white'
              }`}>
                Saldívar Villar
              </span>
              <p className={`text-xs uppercase tracking-wider ${
                isScrolled ? 'text-[#d4af37]' : 'text-[#d4af37]'
              }`}>
                Salón & Spa
              </p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden items-center gap-8 md:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className={`text-sm font-medium tracking-wide transition-colors hover:text-[#d4af37] ${
                  isScrolled ? 'text-neutral-600' : 'text-white/90'
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden items-center gap-4 md:flex">
            <button
              onClick={openWhatsApp}
              className="group flex items-center gap-2 rounded-full bg-gradient-to-r from-[#d4af37] to-[#b8860b] px-5 py-2.5 text-sm font-semibold text-neutral-900 shadow-md transition-all duration-300 hover:shadow-lg hover:shadow-[#d4af37]/20"
            >
              <Phone className="h-4 w-4 transition-transform group-hover:rotate-12" />
              Agendar Cita
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`rounded-lg p-2 md:hidden ${
              isScrolled ? 'text-neutral-700' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`absolute left-0 right-0 top-full bg-white shadow-lg transition-all duration-300 md:hidden border-t border-neutral-100 ${
          isMobileMenuOpen
            ? 'visible translate-y-0 opacity-100'
            : 'invisible -translate-y-4 opacity-0'
        }`}
      >
        <nav className="flex flex-col p-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(link.href);
              }}
              className="border-b border-neutral-100 py-3 text-neutral-700 transition-colors hover:text-[#d4af37]"
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={openWhatsApp}
            className="mt-4 flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#d4af37] to-[#b8860b] py-3 text-neutral-900 font-semibold transition-colors"
          >
            <Phone className="h-4 w-4" />
            Agendar Cita
          </button>
        </nav>
      </div>
    </header>
  );
};
